import type { FC } from 'react';
import { Flex, Shimmer } from '@/_components';
import styles from './LoadingSection.module.css';

export const LoadingSection: FC = () => {
  return (
    <Flex
      isColumn={true}
      gap={12}
      padding={12}
      className={styles.loadingSection}
    >
      <Shimmer width={240} height={16} />
      <Shimmer width={320} height={1} />
      <Flex isColumn={true} gap={4}>
        <Flex gap={4} isWrapping={true}>
          <Shimmer width={200} height={16} />
          <Shimmer width={240} height={16} />
        </Flex>
        <Flex gap={4} isWrapping={true}>
          <Shimmer width={140} height={16} />
          <Shimmer width={80} height={16} />
          <Shimmer width={50} height={16} />
        </Flex>
        <Flex gap={4} isWrapping={true}>
          <Shimmer width={160} height={16} />
          <Shimmer width={100} height={16} />
        </Flex>
      </Flex>
    </Flex>
  );
};
